import { FunctionComponent } from "react";
import { Avatar as MuiAvatar } from "@mui/material";

import { AVATAR_FILLS, BRAND } from "@/theme/tokens";

interface AvatarProps {
	firstName?: string;
	lastName?: string;
	imageSrc?: string;
}

/**
 * §2.6 — six fills, dark enough for white initials and far enough apart to tell two
 * people apart at 24px. Deliberately not the accent: an avatar is not a call to
 * action, and a wall of #FF5A24 circles drowns the one button on the page that is.
 *
 * The fill is picked from the name so the same person keeps the same colour between
 * sessions and between screens.
 */
const pickFill = (seed: string): string => {
	let hash = 0;

	for (let i = 0; i < seed.length; i++) {
		hash = (hash * 31 + seed.charCodeAt(i)) % 1_000_003;
	}

	return AVATAR_FILLS[hash % AVATAR_FILLS.length];
};

export const Avatar: FunctionComponent<AvatarProps> = ({ firstName, lastName, imageSrc }) => {
	const initials =
		firstName && lastName
			? `${firstName.split("")[0].toUpperCase()}${lastName.split("")[0].toUpperCase()}`
			: "";

	return (
		<MuiAvatar
			src={imageSrc}
			sx={{
				height: 32,
				width: 32,
				cursor: "pointer",
				fontSize: 13,
				fontWeight: 700,
				bgcolor: initials ? pickFill(`${firstName}${lastName}`) : BRAND.subtle,
				color: BRAND.white,
			}}
		>
			{initials}
		</MuiAvatar>
	);
};
